export default function (other) {
  other = other || {}
  return {
    id: other.id || null,
    orgId: other.orgId || null,
    campaign: other.campaign || null,
    facebookAccountNumber: other.facebookAccountNumber || null,
    agencyName: other.agencyName || null,
    keitaroCampaignName: other.keitaroCampaignName || null,
    setNumber: other.setNumber || null,
    status: other.status || null,
    importance: other.importance || null,
    pixel: other.pixel || null,
    dailySpend: other.dailySpend || null,
    creationTime: other.creationTime || null,
    toDo: other.toDo || null,
    note: other.note || null,
    trackingLink: other.trackingLink || null,
    alias: other.alias || null,
    catalog: other.catalog || null,
    catalogLink: other.catalogLink || null,
    facebookOrDrive: other.facebookOrDrive || null,
    filesAndMedia: other.filesAndMedia || null,
    assignedTo: other.assignedTo || null,
    priority: other.priority || null,
    formula: other.formula || null,
    isPlaying: other.isPlaying || null
  }
}
